









































































































































import { Component, Mixins } from 'vue-property-decorator';
import AdminUserInfo from '@/components/User/AdminUserInfo.vue';
import InputField from '@/ts/InputField';
import UserMethods from '@/mixins/UserMethods.vue';
import AdminUserInfoBox from '@/components/User/AdminUserInfoBox.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component({
    components: {
        AdminUserInfo,
        AdminUserInfoBox,
    },
})
export default class UserInfo extends Mixins(UserMethods, InputFieldMethods) {
    constructor() {
        super();
    }

    public created() {
        this.inputs['hococo-form-user-info-name'] = new InputField('hococo-form-user-info-name');
        this.inputs['hococo-form-user-info-email'] = new InputField('hococo-form-user-info-email');
        this.inputs['hococo-form-user-info-address'] = new InputField('hococo-form-user-info-address');
        this.inputs['hococo-form-user-info-number'] = new InputField('hococo-form-user-info-number');
        this.inputs['hococo-form-user-info-zipcode'] = new InputField('hococo-form-user-info-zipcode');
        this.inputs['hococo-form-user-info-country'] = new InputField('hococo-form-user-info-country');
    }
}
